module.exports = __webpack_public_path__ + "static/media/FFEP_230316.a588baac.jpg";